/**
 * Canvas heart bar for transient (Fall) and persistent (Shake) HP display.
 */

export function drawHeartsBar(ctx, x, y, maxHp, hp, opts) {
  if (!ctx || maxHp <= 0) return;
  opts = opts || {};
  var size = opts.size != null ? opts.size : 18;
  var gap = opts.gap != null ? opts.gap : 6;
  var filledColor = opts.filledColor || "#ef3349";
  var emptyColor = opts.emptyColor || "rgba(255,255,255,0.35)";
  var totalW = maxHp * size + (maxHp - 1) * gap;
  var startX = x - totalW / 2;
  for (var i = 0; i < maxHp; i++) {
    var filled = i < hp;
    var cx = startX + i * (size + gap) + size / 2;
    var cy = y + size / 2;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(cx, cy + size * 0.32);
    ctx.bezierCurveTo(cx - size * 0.5, cy - size * 0.12, cx - size * 0.5, cy - size * 0.42, cx, cy - size * 0.18);
    ctx.bezierCurveTo(cx + size * 0.5, cy - size * 0.42, cx + size * 0.5, cy - size * 0.12, cx, cy + size * 0.32);
    ctx.closePath();
    ctx.fillStyle = filled ? filledColor : emptyColor;
    ctx.fill();
    if (filled) {
      ctx.strokeStyle = "rgba(255,255,255,0.55)";
      ctx.lineWidth = 1;
      ctx.stroke();
    }
    ctx.restore();
  }
}
